import { render, staticRenderFns } from "./Standby.vue?vue&type=template&id=254802e6&scoped=true"
import script from "./Standby.vue?vue&type=script&lang=js"
export * from "./Standby.vue?vue&type=script&lang=js"
import style0 from "./Standby.vue?vue&type=style&index=0&id=254802e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254802e6",
  null
  
)

export default component.exports